import gql from 'graphql-tag';

import quoteFragments from './quoteFragments';

export default gql`
${quoteFragments}

mutation UpdateQuote($input: QuoteUpdateInput) {
  quoteResponse: updateQuote(input: $input)
    @rest(
      type: "QuoteUpdate"
      path: "BookingAmendment/UpdateBookingAmendmentQuote"
      method: "POST"
    ) {
      quote {
        basketState
        balanceDueDate
        basketHoldExpiryTimestamp
        basketHoldMaxTimestamp
        basketHoldStartTimestamp
        bookingReference
        cancellationPenalty
        cancellationPenaltyApplicableFrom
        campsiteBookings {
          id
          campsite {
            id
            name
            address {
              country
              county
              addressLines
              postCode
            }
            siteCode
            type
          }
          pitches {
            ...Pitch
          }
        }
        crossingBookings @type(name: "CrossingBookings") {
          ...CrossingBooking
        }
        deposit
        departureDate
        errorCode
        extras {
          ...Extra
        }
        quoteId
        outfit {
          externalId
          id
          towHeight
          towLength
          towType
          towMake
          towModel
          vehicleHeight
          vehicleLength
          vehicleMake
          vehicleModel
          vehicleReg
          vehicleType
        }
        partyMembers {
          ...PartyMemberFrag
        }
        product
        status
        totalPrice
      }
    }
}
`;
